import { twMerge } from 'tailwind-merge';

export const Background = ({ className }: { className?: string }) => (
  <div
    className={twMerge(
      "pointer-events-none fixed inset-y-0 left-0 w-screen bg-[url('/images/bg.svg')] bg-cover bg-center",
      className
    )}
  />
);
